
    const data = {"name":"src/core/icons/note-plus","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 13c.7 0 1.37.13 2 .35V9l-6-6H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h8.35c-.22-.63-.35-1.3-.35-2 0-3.31 2.69-6 6-6m-5-8.5 5.5 5.5H14V4.5M23 18v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            